import i18n from '@/plugins/i18n';

export const getInboxTableHeaders = () => {
  return [
    {
      text: i18n.t('table.header.id'),
      align: 'left',
      value: 'id'
    },
    {
      text: i18n.t('table.header.input.date'),
      value: 'inboxStamp'
    },
    {
      text: i18n.t('table.header.inbox'),
      value: 'inboxname',
      sortable: false
    },
    {
      text: i18n.t('table.header.location'),
      value: 'client',
      sortable: false
    },
    {
      text: i18n.t('table.header.filename'),
      value: 'filename'
    },
    {
      text: i18n.t('table.header.actions'),
      sortable: false
    },
    {
      text: i18n.t('table.header.editing'),
      sortable: false,
      value: 'inboxStatus'
    },
    {
      text: i18n.t('table.header.delete.date'),
      value: 'inboxStamp',
      align: 'left'
    }
  ].filter((header) => {
    return !header.isHidden
  });
}
